module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"description":"Description","edit":"Edit","save":"Save","cancel":"Cancel"},"fr":{"description":"Description","edit":"Modifier","save":"Sauvegarder","cancel":"Annuler"},"de":{"description":"Beschreibung","edit":"Modifikator","save":"Zu schützen","cancel":"Stornieren"}}')
  delete Component.options._Ctor
}
